import React from 'react';
import { connect } from 'react-redux';
import Headline from '../components/atoms/Headline';
import BundleDisplay from '../components/molecules/BundleDisplay';
import OptionsDisplay from '../components/molecules/OptionsDisplay';
import PaymentDisplay from '../components/molecules/PaymentDisplay';
import PaymentDisplayOption from '../components/molecules/PaymentDisplayOption';
import OrderFormDataDisplay from '../components/molecules/OrderFormDataDisplay';
import OrderFormLegalCheckbox from '../components/molecules/OrderFormLegalCheckbox';
import OrderFormSepaCheckbox from '../components/molecules/OrderFormSepaCheckbox';
import OrderFormDepCheckboxes from '../components/molecules/OrderFormDepCheckboxes';
import SimpleButton from '../components/atoms/SimpleButton';
import { setCustomerForm } from '../actions/customer';
import { contentChange } from '../actions/content';
import { showTextOverlay } from '../actions/textoverlay';
import { setCheckout, resetCheckout, setCheckoutDep, resetCheckoutDep, setSepa, resetSepa, setFinish, resetFinish } from '../actions/status';
import { checkoutPayever } from '../actions/payever';
import { showNextButton } from '../actions/next';
import { checkInsurance, typeOfInsurance, beautifyPrice } from '../utils';
var AppConfig = require('../config.json');



class CheckoutView extends React.Component {
  constructor(props) {
    super(props);
    this.changeProjectSection = this.changeProjectSection.bind(this);
    this.showInfo = this.showInfo.bind(this);
    this.getInsuranceSpecs = this.getInsuranceSpecs.bind(this);
    this.getOptions = this.getOptions.bind(this);
    this.getDocUploadElement = this.getDocUploadElement.bind(this);
    this.legalClick = this.legalClick.bind(this);
    this.depClick = this.depClick.bind(this);
    this.sepaClick = this.sepaClick.bind(this);
    this.checkCheckout = this.checkCheckout.bind(this);
    this.findConfiguration = this.findConfiguration.bind(this);
    this.getCustomDataElement = this.getCustomDataElement.bind(this);
    this.state = { checked: false };
  }

  componentDidMount() {
    var nextLink = AppConfig.links.finished.url, addStr = '';
    if (this.props.status.payment.type === 'sf'
      && !this.props.payever.rejected
      && !this.props.payever.isError
      && !this.props.payever.isNotice
      && !this.props.payever.isCancelled
      && !this.props.payever.isSuccess
    ) {
      nextLink = AppConfig.links.payever.url;
      addStr = 'Sie können nach Abschluss der Bestellung zwischen Laufzeiten von 3-36 Monate wählen.';
    }
    this.props.dispatch(
      showNextButton({
        link: nextLink,
        label: 'Jetzt kostenpflichtig bestellen',
        addText: addStr,
        watch: 'finish',
        submitDelay: 200
      })
    );


    // if (
    //   this.props.pathname === '/' + AppConfig.links.checkout.url &&
    //   (this.props.linkTo === AppConfig.links.checkout.url ||
    //     this.props.linkTo === '')
    // ) {
    //   this.props.dispatch(
    //     showNextButton({
    //       link: AppConfig.links.finished.url,
    //       label: 'Jetzt kostenpflichtig bestellen',
    //       watch: 'finish',
    //       submitDelay: 200
    //     })
    //   );
    // // }
    // if (this.props.status.payment.type==='sf') {
    //   this.props.dispatch(checkoutPayever());
    // }
    if (this.props.status.order.isset) {
      this.props.dispatch(setCustomerForm(this.props.status.order.form));
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.status.sepa.isset!==this.props.status.sepa.isset || 
      prevProps.status.checkout.isset!==this.props.status.checkout.isset || 
      (this.props.status.project.isDep && prevProps.status.checkoutDep.isset!==this.props.status.checkoutDep.isset)
      ) {
      this.checkCheckout();
    }
  }

  changeProjectSection(link) {
    this.props.dispatch(contentChange(link));
  }

  legalClick(status) {
    if (status) {
      this.props.dispatch(setCheckout());
    } else {
      this.props.dispatch(resetCheckout());
    }
  }

  depClick(status, ticks) {
    if (status) {
			this.props.dispatch(setCheckoutDep({
				isset:true,
				checkboxes: ticks
			}));
		} else {
			this.props.dispatch(resetCheckoutDep());
		}
  }

  sepaClick(status) {
    if (status) {
      this.props.dispatch(setSepa());
    } else {
      this.props.dispatch(resetSepa());
    }
  }

  checkCheckout() {
    var error = false;
    if (this.props.status.payment.type!=='sf') {
      if (!this.props.status.sepa.isset) {
        error = true;
      }
    }
    if(!this.props.status.checkout.isset) {
      error = true;
    }
    if(this.props.status.project.isDep && !this.props.status.checkoutDep.isset) {
      error = true;
    }
    if(error) {
      this.props.dispatch(resetFinish());
    } else {
      this.props.dispatch(setFinish());
    }
  }

  showInfo(type, isGostudent) {
    if(isGostudent) {
      this.props.dispatch(showTextOverlay({
        text:AppConfig.gostudentoverlay.text,
        headline:AppConfig.gostudentoverlay.headline,
        download:AppConfig.gostudentoverlay.download,
        downloadStr:AppConfig.gostudentoverlay.downloadStr,
        download2:AppConfig.gostudentoverlay.download2,
        downloadStr2:AppConfig.gostudentoverlay.downloadStr2
      }));
    } else {
      this.props.dispatch(showTextOverlay({
        text:AppConfig.insuranceoverlay[type].text,
        headline:AppConfig.insuranceoverlay[type].headline,
        download:AppConfig.insuranceoverlay[type].download,
        downloadStr:"» Laden Sie hier die Bedingungen als PDF herunter."
      }));
    }
    
  }

  getInsuranceSpecs() {
    var insurance, insuranceType, opt;
    const bundle = this.props.status.project.data.bundles.find(
      this.findConfiguration
    );
    for (var i = 0; i < this.props.status.options.articleConfig.length; i++) {
      opt = this.props.status.options.articleConfig[i];
      // insurance = checkInsurance(bundle.configuration[opt.configuration].label);
      // insuranceType = typeOfInsurance(bundle.configuration[opt.configuration].label);
      insurance = bundle.configuration[opt.configuration].choices[opt.choices].isInsurance;
      insuranceType = bundle.configuration[opt.configuration].choices[opt.choices].typeOfInsurance;
      if(insurance) {
        return {"active":true, "type":insuranceType};
      }
    }
    return {"active":false, "type":"std"};
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props.pathname === nextProps.pathname;
  }

  getOptions(opt, n) {
    const bundle = this.props.status.project.data.bundles.find(
      this.findConfiguration
    );
    return (
      <OptionsDisplay
        key={`opt_${n}`}
        showInfo={this.showInfo}
        // isInsurance={checkInsurance(bundle.configuration[opt.configuration].label)}
        // typeOfInsurance={typeOfInsurance(bundle.configuration[opt.configuration].label)}
        isGostudent={bundle.configuration[opt.configuration].choices[opt.choices].gostudent}
        isInsurance={bundle.configuration[opt.configuration].choices[opt.choices].isInsurance}
        typeOfInsurance={bundle.configuration[opt.configuration].choices[opt.choices].typeOfInsurance}
        label={bundle.configuration[opt.configuration].label}
        type={bundle.configuration[opt.configuration].preview}
        choice={bundle.configuration[opt.configuration].choices[opt.choices]}
      />
    );
  }
  getDocUploadElement(identifier, n) {
    var tmp;
    const bundle = this.props.status.project.data.bundles.find(
      this.findConfiguration
    );
    for (var i = 0; i < bundle.documents.docs.length; i++) {
      tmp = bundle.documents.docs[i].identifier;
      if (tmp === identifier) {
        return (
          <div className={`col col_${n}`} key={`doc_${n}`}><strong>{`${bundle.documents.docs[i].headline}:`}</strong>
          <p>hochgeladen</p></div>
        );
      }
    }
    return null;
  }
  
  findConfiguration(bundle) {
    return this.props.status.bundle.id === bundle.id;
  }

  getCustomDataElement(itm, n) {
    var elem;
    if (
      !this.props.status.order.form.customdata.hasOwnProperty(itm.key) ||
      this.props.status.order.form.customdata[itm.key] === '' ||
      itm.type === 'hidden'
    ) {
      return null;
    }
    if (itm.type === 'checkbox') {
      elem = (
        <div className={itm.key}>
          <strong>{itm.label}: </strong>
          {this.props.status.order.form.customdata[itm.key] ? 'Ja' : 'Nein'}
        </div>
      );
    } else {
      elem = (
        <div className={itm.key}>
          <strong>{itm.label}: </strong>
          {this.props.status.order.form.customdata[itm.key]}
        </div>
      );
    }
    return (
      <div
        className={`customitem item_${n} type_${itm.type}`}
        key={`customdata_${n}`}
      >
        {elem}
      </div>
    );
  }

  render() {
    const paymentChoice = {
      group: this.props.status.payment.group,
      id: this.props.status.payment.id
    };
    if (this.props.status.payment.group === 'financing') {
      paymentChoice.type = this.props.status.payment.type;
      paymentChoice.data = [
        {
          price: this.props.status.payment.paymentPrice,
          runtime: this.props.status.payment.paymentRuntime
        }
      ];
    } else {
      paymentChoice.type = this.props.status.payment.id;
      paymentChoice.data = [
        {
          price: this.props.status.payment.paymentPrice,
          type: this.props.status.payment.type
        }
      ];
    }
    const bundle = this.props.status.project.data.bundles.find(
      this.findConfiguration
    );
    return (
      <div className="contentview checkout">
        {this.props.status.bundle.isset &&
        this.props.status.options.isset &&
        this.props.status.payment.isset &&
        this.props.status.order.isset ? (
          <div>
            <div className="section bundle">
              <div className="header">
                <Headline typeOf="h3">{`${AppConfig.checkoutview.bundle
                  .headline}:`}</Headline>
              </div>
              <div className="sectioncontent">
                {this.props.status.project.data.bundles
                  .filter(b => b.id === this.props.status.bundle.id)
                  .map((bundle, n) => (
                    <BundleDisplay key={`bundle${n}`} bundle={bundle} />
                  ))}
                  {
                    this.props.status.payment.type!=='sos' && !this.props.status.project.isDep &&
                  (
                  <div className="shipping">
                    <strong>{AppConfig.shipping.label}</strong> <span>{bundle.shippingText}</span>
                  </div>
                   )}
                   {
                    this.props.status.project.isDep &&
                  (
                  <div className="shipping">
                    <strong>{AppConfig.shippingDep.label}</strong> <span>{bundle.depDelivery}</span>
                  </div>
                   )}
                  {
                    this.props.status.payment.type!=='sf' &&
                  (
                <div className="action">
                  <SimpleButton
                    children="Ändern »"
                    onClick={() =>
                      this.changeProjectSection(AppConfig.links.bundles.url)}
                  />
                </div>
                )}
              </div>
            </div>

            <div className="section options">
              <div className="header">
                <Headline typeOf="h3">{`${AppConfig.checkoutview.options
                  .headline}:`}</Headline>
              </div>
              <div className="sectioncontent">
                <div className="optionswrapper">
                  {this.props.status.options.articleConfig.map((opt, n) =>
                    this.getOptions(opt, n)
                  )}
                </div>
                { this.props.status.requestSerial.isset && this.props.status.requestSerial.sn!=="" &&
                  <div><h5>Seriennummer des Gerätes</h5>
                  <p style={{marginTop:"5px"}}>{this.props.status.requestSerial.sn}</p></div>
                }
                {
                    this.props.status.payment.type!=='sf' && 
                  (
                <div className="action">
                  <SimpleButton
                    children="Ändern »"
                    onClick={() =>
                      this.changeProjectSection(AppConfig.links.options.url)}
                  />
                </div>
                )}
              </div>
            </div>

            <div className="section payment">
              <div className="header">
                <Headline typeOf="h3">{`${AppConfig.checkoutview.payment
                  .headline}:`}</Headline>
              </div>
              <div className="sectioncontent">
                <div className="paymentdisplaywrapper selected">
                  <PaymentDisplay choice={paymentChoice} />
                  <div className="optionswrapper">
                    {
                      (this.props.status.payment.type === 'sf' && this.props.payever.isSuccess && this.props.payever.id!==0) ?
                      <PaymentDisplayOption choice={paymentChoice} payeverdata={this.props.payever.details} />
                      :
                      <PaymentDisplayOption choice={paymentChoice} />
                    }
                  </div>
                </div>
                {
                  this.props.status.payment.type!=='sf' && 
                (
                <div className="action">
                  <SimpleButton
                    children="Ändern »"
                    onClick={() =>
                      this.changeProjectSection(AppConfig.links.payment.url)}
                  />
                </div>
                )}
              </div>
            </div>

            <div className="section order personal">
              <div className="header">
                <Headline typeOf="h3">{`${AppConfig.checkoutview.personal
                  .headline}:`}</Headline>
              </div>
              <div className="sectioncontent">
                <div className="datawrapper">
                  <OrderFormDataDisplay
                    type="personal"
                    data={this.props.status.order.form}
                    teacher={this.props.status.project.teachers}
                  />
                  {this.props.status.project.teachers ? (
                  <div className="data">
                  <div className="header">
                    <Headline typeOf="h3">{`${AppConfig.checkoutview.teacher
                      .headline}:`}</Headline>
                  </div>
                    <div className="nameschule">Name der Schule: {this.props.status.order.form.schoolname}</div>
                    
                      <div className={`col col_0`} key={`checkteacher_0`}>
                        <strong>{AppConfig.teacher.upload.label}</strong>: Ja
                      </div>
                  
                  </div>
                ) : null}
                </div>
              </div>
            </div>


            

            {this.props.status.payment.type !== 'rg' &&
            this.props.status.payment.type !== 'vk' &&
            this.props.status.payment.type !== 'sf' ? (
              <div className="section order banking">
                <div className="header">
                  <Headline typeOf="h3">{`${AppConfig.checkoutview.banking
                    .headline}:`}</Headline>
                </div>
                <div className="sectioncontent">
                  <div className="datawrapper">
                    <OrderFormDataDisplay
                      type="banking"
                      data={this.props.status.order.form}
                    />
                  </div>
                </div>
              </div>
            ) : null}

            {this.props.status.order.form.support.length !== 0 ? (
              <div className="section support">
                <div className="header">
                  <Headline typeOf="h3">{`${AppConfig.checkoutview.support
                    .headline}:`}</Headline>
                </div>
                <fieldset name={AppConfig.checkoutview.support.headline}>
                  <div className="data">
                    {this.props.status.order.form.support.map((itm, n) => (
                      <div className={`col col_${n}`} key={`check_${n}`}>
                        <strong>{AppConfig.supportTypes[itm].label}</strong>: Ja
                      </div>
                    ))}
                  </div>
                  {bundle.sponsoring.active && (
                  <div className="sponsoring">
                    <div className="col col_1">
                      <strong>Förderbetrag </strong>: <span dangerouslySetInnerHTML={{__html:beautifyPrice(bundle.sponsoring.supportPrice)}} /> €
                    </div>
                    {bundle.sponsoring.active && this.props.status.payment.type!=='sf' && (
                    <div className="col col_2">
                      <strong>Eigenanteil </strong>: <span dangerouslySetInnerHTML={{__html:beautifyPrice(bundle.sponsoring.customerPrice)}} /> €
                    </div>
                    )}
                  </div>)}
                </fieldset>
              </div>
            ) : null}

            {this.props.status.order.form.documents.length !== 0 ? (
              <div className="section support docs">
                <div className="header">
                  <Headline typeOf="h3">{`${AppConfig.checkoutview.documents
                    .headline}:`}</Headline>
                </div>
                <fieldset name={AppConfig.checkoutview.documents.headline}>
                  <div className="data">
                    {this.props.status.order.form.documents.map((itm, n) => (
                      this.getDocUploadElement(itm, n)
                    ))}
                  </div>
                </fieldset>
              </div>
            ) : null}


            {this.props.status.project.data.customdata.length !== 0 ? (
              <div className="section customdata">
                <div className="header">
                  <Headline typeOf="h3">{`${AppConfig.checkoutview.customdata
                    .headline}:`}</Headline>
                </div>
                <fieldset name={AppConfig.checkoutview.customdata.headline}>
                  <div className="data">
                    {this.props.status.project.data.customdata.map((itm, n) =>
                      this.getCustomDataElement(itm, n)
                    )}
                  </div>
                </fieldset>
              </div>
            ) : null}

            {
              this.props.status.payment.type!=='sf' && 
            (
              <div className="section changedata sepa">
                <div className="sectioncontent">
                <div className="sepa checkbox">
                  <OrderFormSepaCheckbox onClick={this.sepaClick} />
                </div>
                  <div className="action">
                    <SimpleButton
                      children="Ändern »"
                      onClick={() =>
                        this.changeProjectSection(AppConfig.links.order.url)}
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="section checkbox finishaction">
              

              <div className="sectioncontent">
                <OrderFormLegalCheckbox insurance={this.getInsuranceSpecs()} onClick={this.legalClick} />
                {
                  this.props.status.project.isDep &&
                  <OrderFormDepCheckboxes handleStatus={this.depClick} />
                }
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    pathname: state.routing.location.pathname,
    linkTo: state.content.link,
    status: state.status,
    payever: state.payever
  };
};
const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutView);



// WEBPACK FOOTER //
// ./src/views/CheckoutView.js